import React from "react";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import { timeHelper, dateHelper } from "../../../../Utils/datetime_helper";
import { BookText, CalendarDays } from "lucide-react";
// Here all css comes on PublishedAssessBox.css

const ReviewAssessBox = ({ assessment }) => {
  const { id, section_id, standard_id, subject_id, deadline, name } =
    assessment;

  // const timeHelper = (a) => {
  //   const dateObj = new Date(a);
  //   const outputDateString = moment(a).format('DD/MM/YYYY')
  //   return outputDateString;
  // };

  const reduceSubjectName = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.slice(0, length) + "...";
  };

  const subjectColor =
    "#" + (assessment?.subject_id?.subject_color || "000000");

  return (
    <>
      {assessment ? (
        <NavLink
          to="/onreviewstudentlist"
          state={{ assessmentId: id }}
          className="text-dark text-decoration-none w-100"
        >
          <div
            className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 "
            style={{
              backgroundColor: "#FDEFE3",
              borderTop: `4px solid ${subjectColor}`,
              borderRight: "4px solid #8D4B28",
              borderBottom: "1px solid #8D4B28",
              borderLeft: "1px solid #8D4B28",
              borderRadius: "0.75rem",
              minHeight: "97px",
            }}
          >
            {/* Header: Class | Section | Subject */}
            <div className="d-flex gap-2  align-items-start mb-2 poppins-semibold">
              {`${standard_id?.name} - ${section_id?.name} | `}
              <span
                title={subject_id?.name}
                className="poppins-semibold text-truncate"
              >
                {reduceSubjectName(subject_id?.name, 25)}
              </span>
            </div>

            {/* Assessment Name */}
            <div className="d-flex align-items-center mb-1">
              <BookText size={16} className="me-2 text-dark" />
              <div className="text-truncate poppins-semibold" title={name}>
                {name}
              </div>
            </div>

            {/* Scheduled Date & Time */}
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontSize: "0.875rem" }}
            >
              <CalendarDays size={16} className="me-2 text-dark" />
              <div className="d-flex flex-column">
                <smal className="me-1">Scheduled On:</smal>
                <div>
                  <small className="text-dark">
                    {dateHelper(assessment?.schedule_date || "")}
                    {" - "}
                    {timeHelper(assessment?.schedule_time || "")}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </NavLink>
      ) : (
        <></>
      )}
    </>
  );
};

export default ReviewAssessBox;
